import type { Slot, SlotId } from "../../schemas/index.ts";
import type { NodeDesignsState } from "../types.ts";

const slotHasIdCreate = (id: number) => (slot: Slot) => slot.placeholderId === id || slot.residentId === id;

export const getNodeSlotId = (
  parentIdByChildId: NodeDesignsState["parentIdByChildId"],
  slotsByParentId: NodeDesignsState["slotsByParentId"],
  id: number,
): (SlotId & { isPlaceholder?: true }) | undefined => {
  const parentId = parentIdByChildId[id];
  if (!parentId) {
    return undefined;
  }
  const isMatch = slotHasIdCreate(id);

  const slotsByName = slotsByParentId[parentId] ?? {};
  const matchingEntry = Object.entries(slotsByName).find(([, idOrIds]) =>
    Array.isArray(idOrIds) ? idOrIds.find(isMatch) : isMatch(idOrIds),
  );
  if (!matchingEntry) {
    return undefined;
  }
  const [name, idOrIds] = matchingEntry;
  const index = Array.isArray(idOrIds) ? idOrIds.findIndex(isMatch) : undefined;

  const isPlaceholder = Array.isArray(idOrIds)
    ? index !== undefined
      ? idOrIds[index].placeholderId === id
      : undefined
    : idOrIds.placeholderId === id;

  return {
    parentId,
    name,
    index,
    isPlaceholder: isPlaceholder || undefined,
  };
};

export const getNodeSlotIdCreate = (state: NodeDesignsState) => (id: number) => {
  const { parentIdByChildId, slotsByParentId } = state;
  return getNodeSlotId(parentIdByChildId, slotsByParentId, id);
};

export type GetNodeSlotId = ReturnType<typeof getNodeSlotIdCreate>;
